/**
 * @generated SignedSource<<c530b04d3a74c3cc1a7228bf822db39e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type moveProductsToCategoryDialogQuery$variables = Record<PropertyKey, never>;
export type moveProductsToCategoryDialogQuery$data = {
  readonly merchantProductCategoryHierarchy: {
    readonly macroCategories: ReadonlyArray<{
      readonly categories: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
      readonly id: string;
      readonly name: string;
    }>;
  };
};
export type moveProductsToCategoryDialogQuery = {
  response: moveProductsToCategoryDialogQuery$data;
  variables: moveProductsToCategoryDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductCategoryHierarchy",
    "kind": "LinkedField",
    "name": "merchantProductCategoryHierarchy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductMacroCategory",
        "kind": "LinkedField",
        "name": "macroCategories",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCategory",
            "kind": "LinkedField",
            "name": "categories",
            "plural": true,
            "selections": [
              (v0/*:: as any*/),
              (v1/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "moveProductsToCategoryDialogQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "moveProductsToCategoryDialogQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "465aeaf3ef262c3bd44cfe252830ce76",
    "id": null,
    "metadata": {},
    "name": "moveProductsToCategoryDialogQuery",
    "operationKind": "query",
    "text": "query moveProductsToCategoryDialogQuery {\n  merchantProductCategoryHierarchy {\n    macroCategories {\n      id\n      name\n      categories {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da3a19fddbbc4a9082ac0475e2170cda";

export default node;
